var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Admin schedule for "+_vm._s(_vm.adminId))])
}
var staticRenderFns = []

export { render, staticRenderFns }